import React from 'react';
import dayjs from 'dayjs';
import Button from '@/components/Button';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  startDate: string | null;
  endDate: string | null;
  isSubmitting: boolean;
};

const formatScheduleDateTime = (value: dayjs.Dayjs) =>
  value.format('ddd, MMM D YYYY [at] h:mm A');

const FilledJobScheduleConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  startDate,
  endDate,
  isSubmitting,
}: Props) => {
  if (!isOpen || !startDate || !endDate) return null;

  const startDateTime = dayjs(Number(startDate));
  const endDateTime = dayjs(Number(endDate));

  const handleCancel = () => {
    if (isSubmitting) return;
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 px-4 py-8 sm:px-6">
      <div className="w-full max-w-lg rounded-lg bg-white p-6 shadow-xl">
        <h3 className="text-xl font-bold text-gray-800">
          Confirm schedule update
        </h3>
        <p className="mt-3 text-sm text-gray-700">
          You are about to edit this filled job to these dates and times. Are
          you sure this candidate has been informed and you would like to
          proceed?
        </p>

        <div className="mt-4 rounded-md border border-gray-200 bg-gray-50 p-4">
          <dl className="space-y-2 text-sm">
            <div className="flex justify-between gap-4">
              <dt className="font-medium text-gray-600">Start</dt>
              <dd className="text-right text-gray-900">
                {formatScheduleDateTime(startDateTime)}
              </dd>
            </div>
            <div className="flex justify-between gap-4">
              <dt className="font-medium text-gray-600">End</dt>
              <dd className="text-right text-gray-900">
                {formatScheduleDateTime(endDateTime)}
              </dd>
            </div>
          </dl>
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <Button
            variant="outline"
            type="button"
            onClick={handleCancel}
            disabled={isSubmitting}
            className="py-2 text-sm"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            type="button"
            onClick={onConfirm}
            disabled={isSubmitting}
            className="py-2 text-sm"
          >
            {isSubmitting ? 'Saving...' : 'Yes, update schedule'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilledJobScheduleConfirmModal;
